module.exports = __webpack_public_path__ + "img/album07_38.6b7b22a7.jpg";